export default __webpack_public_path__ + "static/media/01.ebb39591.png";